'use strict';

export default value => {
  let display = '';

  if (value) {
    display = value;
  } else {
    display = '-';
  }
  return display;
};
